import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { shallowEqual, useSelector } from "react-redux";
import ErrorLink from "./ErrorLink";
import checkErrors from "../nodes/Logic/helpers/checkErrors";

export default function Errors({
  filterFn = () => true,
  countOnly,
  exclamationMarkOnly,
  linkDisabled,
}) {
  const errors = useSelector(
    (state) => checkErrors(state),
    shallowEqual
  ).filter(filterFn);

  const errorList = (
    <ul className="text-danger p-0" style={{ listStyle: "none" }}>
      {errors.map((err, index) => (
        <li key={index}>
          {linkDisabled ? (
            <span>{err.error.text}</span>
          ) : (
            <ErrorLink err={err} />
          )}
        </li>
      ))}
    </ul>
  );

  if (countOnly) {
    return errors.length;
  }

  if (exclamationMarkOnly && errors.length > 0) {
    return (
      <OverlayTrigger
        trigger={["hover", "click", "focus"]}
        placement="auto"
        overlay={
          <Popover id="popover-errors" body>
            {errorList}
          </Popover>
        }
        rootClose
      >
        <FontAwesomeIcon
          icon={faExclamationTriangle}
          className="mx-2 text-danger"
        />
      </OverlayTrigger>
    );
  }

  return errors.length > 0 && errorList;
}
